import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-mr-2" }, "Seguimiento Staff", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ModuleHeader, { showGoBack: false }, {
            title: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_TabMenu, { model: _ctx.menuItems }, null, 8, ["model"]),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  allCoursePlans: _ctx.allCoursePlans,
                  key: _ctx.$route.fullPath
                }, null, 8, ["allCoursePlans"]))
              ], 1024))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}